import React from 'react';
import { useNavigate } from 'react-router-dom';
import SteamAuthButton from './SteamAuthButton';

const Header: React.FC = () => {
    const navigate = useNavigate();

    const handleLogoClick = () => {
        navigate('/');
    };

    return (
        <header className="h-[70px] flex justify-between items-center p-2 bg-gradient-to-r from-slate-800 to-gray-800 text-white w-full drop-shadow-md">
            <div
                onClick={handleLogoClick}
                className="cursor-pointer ml-4 transition-all duration-300 group"
                style={{ marginLeft: '10px' }}
            >
                <h1
                    className="text-white text-3xl font-bold transition-transform duration-300 group-hover:skew-x-[-6deg] relative"
                    style={{ fontFamily: 'Tektur, serif' }}
                >
                    MOROZ MODS <span
                        className="absolute bottom-0 left-0 right-14 h-0.5 bg-white transform scale-x-0 origin-left transition-transform duration-300 group-hover:scale-x-100"
                    />
                </h1>
                <p className="text-sm text-slate-400 font-semibold" style={{ fontFamily: 'Tektur, serif'}}>
                    ⛄The best vehicles for your server
                </p>
            </div>
            <SteamAuthButton />
        </header>
    );
};

export default Header;